import { render, staticRenderFns } from "./SuppliesLeadFormResult.vue?vue&type=template&id=641a69f2&"
import script from "./SuppliesLeadFormResult.vue?vue&type=script&lang=ts&"
export * from "./SuppliesLeadFormResult.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports